import script from "./PromiseButton.vue?vue&type=script&setup=true&lang=js"
export * from "./PromiseButton.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__